import { httpRequest } from "../../http";
import { brandColorsUrl } from "./cmdGetBrandColors";

/** Archives a color row. On a legacy slot the server resets the column to its default. */
export class CommandArchiveBrandColor {
    async run(organizationId: string, brandId: string, colorId: string) {
        const url = `${brandColorsUrl(organizationId, brandId)}${encodeURIComponent(colorId)}/`;
        return await httpRequest<string>(url, { method: "DELETE" });
    }
}
